const PROJECT_TASK_ORDER_STORAGE_PREFIX = 'project-task-order'

function getProjectTaskOrderStorageKey(projectId: string | number) {
    return `${PROJECT_TASK_ORDER_STORAGE_PREFIX}:${projectId}`
}

export function readProjectTaskOrder(projectId?: string | number | null) {
    if (projectId == null) {
        return []
    }

    try {
        const rawValue = localStorage.getItem(getProjectTaskOrderStorageKey(projectId))

        if (!rawValue) {
            return []
        }

        const parsedValue = JSON.parse(rawValue)

        return Array.isArray(parsedValue)
            ? parsedValue.map((id) => String(id))
            : []
    } catch (error) {
        return []
    }
}

export function writeProjectTaskOrder(projectId: string | number, tasks: Array<{ id: string | number }>) {
    try {
        localStorage.setItem(
            getProjectTaskOrderStorageKey(projectId),
            JSON.stringify(tasks.map((task) => String(task.id)))
        )
    } catch (error) {
        console.error('Failed to persist task order:', error)
    }
}

export function sortTasksBySavedOrder<T extends { id: string | number }>(
    tasks: T[],
    savedOrder: string[]
) {
    if (!savedOrder.length) {
        return tasks
    }

    const savedOrderIndexMap = new Map(savedOrder.map((id, index) => [String(id), index]))

    return [...tasks].sort((leftTask, rightTask) => {
        const leftIndex = savedOrderIndexMap.get(String(leftTask.id))
        const rightIndex = savedOrderIndexMap.get(String(rightTask.id))

        if (leftIndex == null && rightIndex == null) {
            return 0
        }

        if (leftIndex == null) {
            return 1
        }

        if (rightIndex == null) {
            return -1
        }

        return leftIndex - rightIndex
    })
}
